import { gql } from "@apollo/client";

export const PRODUCT_COMPANY_COUNT_QUERY = gql`
  query productInstallQuery(
    $productId: Int!
    $localizeInstalls: Boolean!
    $isDp: Boolean
    $isDu: Boolean
    $isGhq: Boolean
    $isGp: Boolean
    $isGu: Boolean
  ) {
    opportunityGeneratorSearch(
      filters: {
        products: [{ ids: [$productId], inclusionMethod: ANY_PRESENT }]
        isDp: $isDp
        isDu: $isDu
        isGhq: $isGhq
        isGp: $isGp
        isGu: $isGu
      }
      localizeInstalls: $localizeInstalls
    ) {
      data {
        name
        hgId
        url
        countryName
        revenueRange {
          min
          max
          band
        }
      }
      count
    }
  }
`;
